<template>
  <VDialog v-model="dialog" width="90%">
    <VCard>
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center">{{ $t("tmtPlacement") }}</VCardTitle>
      <VCardText>
        <span v-for="(item, index) in productItems" :key="item.id"
          >{{ item.productName }}
          <span
            v-if="productItems.length > 1 && index !== productItems.length - 1"
            >,
          </span></span
        >
        <ProductPlacement
          class="mt-2"
          :data="boardData"
          :warehouseName="warehouseName"
          :productItemIds="productItemIds"
          :fromWarehouseId="fromWarehouseId"
          :selectedProductId="selectedProductId"
          :toWarehouseId="warehouseId"
          @place-here="$emit('place-here')"
          ref="productPlacementRef"
          @clearProductItemIds="$emit('clearProductItemIds')"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import ProductPlacement from "@/components/omtk/ProductPlacement.vue";
import { BoxService } from "@/services/BoxService.js";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants.js";

export default {
  data() {
    return {
      dialog: false,
      warehouseId: null,
      fromWarehouseId: null,
      boardData: {
        boards: [],
        columns: [],
        rows: [],
      },
      warehouseName: null,
    };
  },
  props: {
    productItemIds: {
      type: Array,
      required: true,
    },
    productItems: {
      type: Array,
      required: true,
    },
    selectedProductId: {
      type: String,
    },
  },
  components: {
    ProductPlacement,
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$refs.productPlacementRef.clearSelectedStillages();
      }
    },
  },
  methods: {
    async getWarehouseName() {
      try {
        const {
          data: { data },
        } = await this.$http.get("warehouse/get-item/", {
          params: {
            id: this.warehouseId,
          },
        });
        this.warehouseName = data.name;
      } catch (err) {
        this.setResponseError({ error: err });
      }
    },
    async getBoardData() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("warehouse/board", {
          params: {
            id: this.warehouseId,
          },
        });
        const boxService = new BoxService(DEFAULT_STILLAGE_BOX_SIZE);
        this.boardData = boxService.parseData(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open(warehouseId, fromWarehouseId) {
      this.dialog = true;
      this.warehouseId = warehouseId;
      this.fromWarehouseId = fromWarehouseId;
      this.getWarehouseName();
      this.getBoardData();
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>
